<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @openEditForm="openEditForm"
    >
      <template #header>
        <div class="d-flex align-items-center">
          <h6 class="mb-0">
            {{ $l('table_header_color') || '面料颜色及花型' }}
          </h6>
          <el-divider direction="vertical" v-if="!disabled" />
          <el-button
            v-if="!disabled"
            style="font-size: 14px;"
            type="text"
            @click="openEditForm()"
          >
            {{ $l('btn_addColor') || '添加颜色及花型' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :fabricCode="fabricCode"
      :fabricColorCode="editFormOpts.fabricColorCode"
      @reload="getData"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditForm from './components/edit-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, EditForm },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    fabricCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      editFormOpts: { visible: false, fabricColorCode: '' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.fabricCode) return
      this.loading = true
      const params = { fabricCode: this.fabricCode }
      const res = await this.$api
        .masterFabricColor_ListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    openEditForm({ fabricColorCode } = {}) {
      this.editFormOpts = { visible: true, fabricColorCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
